import * as React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Check, ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

const countries = [
  { code: "AD", name: "Andorra", dial: "+376" },
  { code: "AE", name: "United Arab Emirates", dial: "+971" },
  { code: "AF", name: "Afghanistan", dial: "+93" },
  { code: "AG", name: "Antigua and Barbuda", dial: "+1268" },
  { code: "AI", name: "Anguilla", dial: "+1264" },
  { code: "AL", name: "Albania", dial: "+355" },
  { code: "AM", name: "Armenia", dial: "+374" },
  { code: "AO", name: "Angola", dial: "+244" },
  { code: "AQ", name: "Antarctica", dial: "+672" },
  { code: "AR", name: "Argentina", dial: "+54" },
  { code: "AS", name: "American Samoa", dial: "+1684" },
  { code: "AT", name: "Austria", dial: "+43" },
  { code: "AU", name: "Australia", dial: "+61" },
  { code: "AW", name: "Aruba", dial: "+297" },
  { code: "AX", name: "Åland Islands", dial: "+358" },
  { code: "AZ", name: "Azerbaijan", dial: "+994" },
  { code: "BA", name: "Bosnia and Herzegovina", dial: "+387" },
  { code: "BB", name: "Barbados", dial: "+1246" },
  { code: "BD", name: "Bangladesh", dial: "+880" },
  { code: "BE", name: "Belgium", dial: "+32" },
  { code: "BF", name: "Burkina Faso", dial: "+226" },
  { code: "BG", name: "Bulgaria", dial: "+359" },
  { code: "BH", name: "Bahrain", dial: "+973" },
  { code: "BI", name: "Burundi", dial: "+257" },
  { code: "BJ", name: "Benin", dial: "+229" },
  { code: "BL", name: "Saint Barthélemy", dial: "+590" },
  { code: "BM", name: "Bermuda", dial: "+1441" },
  { code: "BN", name: "Brunei", dial: "+673" },
  { code: "BO", name: "Bolivia", dial: "+591" },
  { code: "BQ", name: "Caribbean Netherlands", dial: "+599" },
  { code: "BR", name: "Brazil", dial: "+55" },
  { code: "BS", name: "Bahamas", dial: "+1242" },
  { code: "BT", name: "Bhutan", dial: "+975" },
  { code: "BV", name: "Bouvet Island", dial: "+47" },
  { code: "BW", name: "Botswana", dial: "+267" },
  { code: "BY", name: "Belarus", dial: "+375" },
  { code: "BZ", name: "Belize", dial: "+501" },
  { code: "CA", name: "Canada", dial: "+1" },
  { code: "CC", name: "Cocos Islands", dial: "+61" },
  { code: "CD", name: "Democratic Republic of the Congo", dial: "+243" },
  { code: "CF", name: "Central African Republic", dial: "+236" },
  { code: "CG", name: "Republic of the Congo", dial: "+242" },
  { code: "CH", name: "Switzerland", dial: "+41" },
  { code: "CI", name: "Côte d'Ivoire", dial: "+225" },
  { code: "CK", name: "Cook Islands", dial: "+682" },
  { code: "CL", name: "Chile", dial: "+56" },
  { code: "CM", name: "Cameroon", dial: "+237" },
  { code: "CN", name: "China", dial: "+86" },
  { code: "CO", name: "Colombia", dial: "+57" },
  { code: "CR", name: "Costa Rica", dial: "+506" },
  { code: "CU", name: "Cuba", dial: "+53" },
  { code: "CV", name: "Cape Verde", dial: "+238" },
  { code: "CW", name: "Curaçao", dial: "+599" },
  { code: "CX", name: "Christmas Island", dial: "+61" },
  { code: "CY", name: "Cyprus", dial: "+357" },
  { code: "CZ", name: "Czech Republic", dial: "+420" },
  { code: "DE", name: "Germany", dial: "+49" },
  { code: "DJ", name: "Djibouti", dial: "+253" },
  { code: "DK", name: "Denmark", dial: "+45" },
  { code: "DM", name: "Dominica", dial: "+1767" },
  { code: "DO", name: "Dominican Republic", dial: "+1809" },
  { code: "DZ", name: "Algeria", dial: "+213" },
  { code: "EC", name: "Ecuador", dial: "+593" },
  { code: "EE", name: "Estonia", dial: "+372" },
  { code: "EG", name: "Egypt", dial: "+20" },
  { code: "EH", name: "Western Sahara", dial: "+212" },
  { code: "ER", name: "Eritrea", dial: "+291" },
  { code: "ES", name: "Spain", dial: "+34" },
  { code: "ET", name: "Ethiopia", dial: "+251" },
  { code: "FI", name: "Finland", dial: "+358" },
  { code: "FJ", name: "Fiji", dial: "+679" },
  { code: "FK", name: "Falkland Islands", dial: "+500" },
  { code: "FM", name: "Micronesia", dial: "+691" },
  { code: "FO", name: "Faroe Islands", dial: "+298" },
  { code: "FR", name: "France", dial: "+33" },
  { code: "GA", name: "Gabon", dial: "+241" },
  { code: "GB", name: "United Kingdom", dial: "+44" },
  { code: "GD", name: "Grenada", dial: "+1473" },
  { code: "GE", name: "Georgia", dial: "+995" },
  { code: "GF", name: "French Guiana", dial: "+594" },
  { code: "GG", name: "Guernsey", dial: "+44" },
  { code: "GH", name: "Ghana", dial: "+233" },
  { code: "GI", name: "Gibraltar", dial: "+350" },
  { code: "GL", name: "Greenland", dial: "+299" },
  { code: "GM", name: "Gambia", dial: "+220" },
  { code: "GN", name: "Guinea", dial: "+224" },
  { code: "GP", name: "Guadeloupe", dial: "+590" },
  { code: "GQ", name: "Equatorial Guinea", dial: "+240" },
  { code: "GR", name: "Greece", dial: "+30" },
  { code: "GS", name: "South Georgia", dial: "+500" },
  { code: "GT", name: "Guatemala", dial: "+502" },
  { code: "GU", name: "Guam", dial: "+1671" },
  { code: "GW", name: "Guinea-Bissau", dial: "+245" },
  { code: "GY", name: "Guyana", dial: "+592" },
  { code: "HK", name: "Hong Kong", dial: "+852" },
  { code: "HM", name: "Heard Island", dial: "+672" },
  { code: "HN", name: "Honduras", dial: "+504" },
  { code: "HR", name: "Croatia", dial: "+385" },
  { code: "HT", name: "Haiti", dial: "+509" },
  { code: "HU", name: "Hungary", dial: "+36" },
  { code: "ID", name: "Indonesia", dial: "+62" },
  { code: "IE", name: "Ireland", dial: "+353" },
  { code: "IL", name: "Israel", dial: "+972" },
  { code: "IM", name: "Isle of Man", dial: "+44" },
  { code: "IN", name: "India", dial: "+91" },
  { code: "IO", name: "British Indian Ocean Territory", dial: "+246" },
  { code: "IQ", name: "Iraq", dial: "+964" },
  { code: "IR", name: "Iran", dial: "+98" },
  { code: "IS", name: "Iceland", dial: "+354" },
  { code: "IT", name: "Italy", dial: "+39" },
  { code: "JE", name: "Jersey", dial: "+44" },
  { code: "JM", name: "Jamaica", dial: "+1876" },
  { code: "JO", name: "Jordan", dial: "+962" },
  { code: "JP", name: "Japan", dial: "+81" },
  { code: "KE", name: "Kenya", dial: "+254" },
  { code: "KG", name: "Kyrgyzstan", dial: "+996" },
  { code: "KH", name: "Cambodia", dial: "+855" },
  { code: "KI", name: "Kiribati", dial: "+686" },
  { code: "KM", name: "Comoros", dial: "+269" },
  { code: "KN", name: "Saint Kitts and Nevis", dial: "+1869" },
  { code: "KP", name: "North Korea", dial: "+850" },
  { code: "KR", name: "South Korea", dial: "+82" },
  { code: "KW", name: "Kuwait", dial: "+965" },
  { code: "KY", name: "Cayman Islands", dial: "+1345" },
  { code: "KZ", name: "Kazakhstan", dial: "+7" },
  { code: "LA", name: "Laos", dial: "+856" },
  { code: "LB", name: "Lebanon", dial: "+961" },
  { code: "LC", name: "Saint Lucia", dial: "+1758" },
  { code: "LI", name: "Liechtenstein", dial: "+423" },
  { code: "LK", name: "Sri Lanka", dial: "+94" },
  { code: "LR", name: "Liberia", dial: "+231" },
  { code: "LS", name: "Lesotho", dial: "+266" },
  { code: "LT", name: "Lithuania", dial: "+370" },
  { code: "LU", name: "Luxembourg", dial: "+352" },
  { code: "LV", name: "Latvia", dial: "+371" },
  { code: "LY", name: "Libya", dial: "+218" },
  { code: "MA", name: "Morocco", dial: "+212" },
  { code: "MC", name: "Monaco", dial: "+377" },
  { code: "MD", name: "Moldova", dial: "+373" },
  { code: "ME", name: "Montenegro", dial: "+382" },
  { code: "MF", name: "Saint Martin", dial: "+590" },
  { code: "MG", name: "Madagascar", dial: "+261" },
  { code: "MH", name: "Marshall Islands", dial: "+692" },
  { code: "MK", name: "North Macedonia", dial: "+389" },
  { code: "ML", name: "Mali", dial: "+223" },
  { code: "MM", name: "Myanmar", dial: "+95" },
  { code: "MN", name: "Mongolia", dial: "+976" },
  { code: "MO", name: "Macao", dial: "+853" },
  { code: "MP", name: "Northern Mariana Islands", dial: "+1670" },
  { code: "MQ", name: "Martinique", dial: "+596" },
  { code: "MR", name: "Mauritania", dial: "+222" },
  { code: "MS", name: "Montserrat", dial: "+1664" },
  { code: "MT", name: "Malta", dial: "+356" },
  { code: "MU", name: "Mauritius", dial: "+230" },
  { code: "MV", name: "Maldives", dial: "+960" },
  { code: "MW", name: "Malawi", dial: "+265" },
  { code: "MX", name: "Mexico", dial: "+52" },
  { code: "MY", name: "Malaysia", dial: "+60" },
  { code: "MZ", name: "Mozambique", dial: "+258" },
  { code: "NA", name: "Namibia", dial: "+264" },
  { code: "NC", name: "New Caledonia", dial: "+687" },
  { code: "NE", name: "Niger", dial: "+227" },
  { code: "NF", name: "Norfolk Island", dial: "+672" },
  { code: "NG", name: "Nigeria", dial: "+234" },
  { code: "NI", name: "Nicaragua", dial: "+505" },
  { code: "NL", name: "Netherlands", dial: "+31" },
  { code: "NO", name: "Norway", dial: "+47" },
  { code: "NP", name: "Nepal", dial: "+977" },
  { code: "NR", name: "Nauru", dial: "+674" },
  { code: "NU", name: "Niue", dial: "+683" },
  { code: "NZ", name: "New Zealand", dial: "+64" },
  { code: "OM", name: "Oman", dial: "+968" },
  { code: "PA", name: "Panama", dial: "+507" },
  { code: "PE", name: "Peru", dial: "+51" },
  { code: "PF", name: "French Polynesia", dial: "+689" },
  { code: "PG", name: "Papua New Guinea", dial: "+675" },
  { code: "PH", name: "Philippines", dial: "+63" },
  { code: "PK", name: "Pakistan", dial: "+92" },
  { code: "PL", name: "Poland", dial: "+48" },
  { code: "PM", name: "Saint Pierre and Miquelon", dial: "+508" },
  { code: "PN", name: "Pitcairn", dial: "+64" },
  { code: "PR", name: "Puerto Rico", dial: "+1787" },
  { code: "PS", name: "Palestine", dial: "+970" },
  { code: "PT", name: "Portugal", dial: "+351" },
  { code: "PW", name: "Palau", dial: "+680" },
  { code: "PY", name: "Paraguay", dial: "+595" },
  { code: "QA", name: "Qatar", dial: "+974" },
  { code: "RE", name: "Réunion", dial: "+262" },
  { code: "RO", name: "Romania", dial: "+40" },
  { code: "RS", name: "Serbia", dial: "+381" },
  { code: "RU", name: "Russia", dial: "+7" },
  { code: "RW", name: "Rwanda", dial: "+250" },
  { code: "SA", name: "Saudi Arabia", dial: "+966" },
  { code: "SB", name: "Solomon Islands", dial: "+677" },
  { code: "SC", name: "Seychelles", dial: "+248" },
  { code: "SD", name: "Sudan", dial: "+249" },
  { code: "SE", name: "Sweden", dial: "+46" },
  { code: "SG", name: "Singapore", dial: "+65" },
  { code: "SH", name: "Saint Helena", dial: "+290" },
  { code: "SI", name: "Slovenia", dial: "+386" },
  { code: "SJ", name: "Svalbard and Jan Mayen", dial: "+47" },
  { code: "SK", name: "Slovakia", dial: "+421" },
  { code: "SL", name: "Sierra Leone", dial: "+232" },
  { code: "SM", name: "San Marino", dial: "+378" },
  { code: "SN", name: "Senegal", dial: "+221" },
  { code: "SO", name: "Somalia", dial: "+252" },
  { code: "SR", name: "Suriname", dial: "+597" },
  { code: "SS", name: "South Sudan", dial: "+211" },
  { code: "ST", name: "São Tomé and Príncipe", dial: "+239" },
  { code: "SV", name: "El Salvador", dial: "+503" },
  { code: "SX", name: "Sint Maarten", dial: "+1721" },
  { code: "SY", name: "Syria", dial: "+963" },
  { code: "SZ", name: "Eswatini", dial: "+268" },
  { code: "TC", name: "Turks and Caicos Islands", dial: "+1649" },
  { code: "TD", name: "Chad", dial: "+235" },
  { code: "TF", name: "French Southern Territories", dial: "+262" },
  { code: "TG", name: "Togo", dial: "+228" },
  { code: "TH", name: "Thailand", dial: "+66" },
  { code: "TJ", name: "Tajikistan", dial: "+992" },
  { code: "TK", name: "Tokelau", dial: "+690" },
  { code: "TL", name: "Timor-Leste", dial: "+670" },
  { code: "TM", name: "Turkmenistan", dial: "+993" },
  { code: "TN", name: "Tunisia", dial: "+216" },
  { code: "TO", name: "Tonga", dial: "+676" },
  { code: "TR", name: "Turkey", dial: "+90" },
  { code: "TT", name: "Trinidad and Tobago", dial: "+1868" },
  { code: "TV", name: "Tuvalu", dial: "+688" },
  { code: "TW", name: "Taiwan", dial: "+886" },
  { code: "TZ", name: "Tanzania", dial: "+255" },
  { code: "UA", name: "Ukraine", dial: "+380" },
  { code: "UG", name: "Uganda", dial: "+256" },
  { code: "UM", name: "United States Minor Outlying Islands", dial: "+1" },
  { code: "US", name: "United States", dial: "+1" },
  { code: "UY", name: "Uruguay", dial: "+598" },
  { code: "UZ", name: "Uzbekistan", dial: "+998" },
  { code: "VA", name: "Vatican City", dial: "+39" },
  { code: "VC", name: "Saint Vincent and the Grenadines", dial: "+1784" },
  { code: "VE", name: "Venezuela", dial: "+58" },
  { code: "VG", name: "British Virgin Islands", dial: "+1284" },
  { code: "VI", name: "United States Virgin Islands", dial: "+1340" },
  { code: "VN", name: "Vietnam", dial: "+84" },
  { code: "VU", name: "Vanuatu", dial: "+678" },
  { code: "WF", name: "Wallis and Futuna", dial: "+681" },
  { code: "WS", name: "Samoa", dial: "+685" },
  { code: "XK", name: "Kosovo", dial: "+383" },
  { code: "YE", name: "Yemen", dial: "+967" },
  { code: "YT", name: "Mayotte", dial: "+262" },
  { code: "ZA", name: "South Africa", dial: "+27" },
  { code: "ZM", name: "Zambia", dial: "+260" },
  { code: "ZW", name: "Zimbabwe", dial: "+263" }
];

interface PhoneInputProps {
  value?: string;
  onChange?: (value: string) => void;
  countryCode?: string;
  onCountryCodeChange?: (code: string) => void;
  placeholder?: string;
  className?: string;
}

export const PhoneInput = React.forwardRef<HTMLInputElement, PhoneInputProps>(
  ({ value, onChange, countryCode = "US", onCountryCodeChange, placeholder = "Phone number", className }, ref) => {
    const [open, setOpen] = React.useState(false);
    const selectedCountry = countries.find(c => c.code === countryCode) || countries[0];

    return (
      <div className={cn("flex", className)}>
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <Button
              variant="outline"
              role="combobox"
              aria-expanded={open}
              className="w-[140px] justify-between rounded-r-none border-r-0 bg-background"
            >
              <span className="flex items-center gap-2">
                <span className="text-sm">{selectedCountry.dial}</span>
              </span>
              <ChevronDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-[300px] p-0">
            <Command>
              <CommandInput placeholder="Search country..." />
              <CommandList>
                <CommandEmpty>No country found.</CommandEmpty>
                <CommandGroup>
                  {countries.map((country) => (
                    <CommandItem
                      key={country.code}
                      value={`${country.name} ${country.dial}`}
                      onSelect={() => {
                        onCountryCodeChange?.(country.code);
                        setOpen(false);
                      }}
                    >
                      <Check
                        className={cn(
                          "mr-2 h-4 w-4",
                          countryCode === country.code ? "opacity-100" : "opacity-0"
                        )}
                      />
                      <span className="flex items-center justify-between w-full">
                        <span>{country.name}</span>
                        <span className="text-muted-foreground">{country.dial}</span>
                      </span>
                    </CommandItem>
                  ))}
                </CommandGroup>
              </CommandList>
            </Command>
          </PopoverContent>
        </Popover>
        <Input
          ref={ref}
          type="tel"
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          placeholder={placeholder}
          className="rounded-l-none"
        />
      </div>
    );
  }
);

PhoneInput.displayName = "PhoneInput";